DialogDateCtrl.$inject = ['$log', '$scope'];
export default function DialogDateCtrl($log, $scope) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.items = null;
    vm.cargando = {
        datos: false,
        submit: false
    };

    vm.formDeshabilitado = false;
    vm.modoEdicion = false;
    vm.reparadores = null;

    vm.submit = function (item) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        vm.model.callbackSubmit(item).then(function (data) {
            vm.dialogHandler.close(data);
        }, function (err) {
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        });
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }

}